import React, {useEffect} from 'react'
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeIntegerInput from "../../components/inputs/NoticeIntegerInput";
import NoticeTypography from "../../components/inputs/NoticeTypography";
import Typography from "components/Typography";
import PlusOneIcon from '@material-ui/icons/PlusOne';
import Tr from 'translations/Translations';
import Button from "components/Button";
import PurchaserDataTogetherList from "./PurchaserDataTogetherList";
import getObjectValue from "libs/getObjectValue";
import {FieldArray} from "formik";

function PurchaserDataTogether(
    {
        id,
        formikProps
    }) {

    const editable = getObjectValue('_editable', formikProps.values, true);
    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);

    useEffect(() => {
        if (getObjectValue(id, formikProps.values, null) == null) {
            formikProps.setFieldValue(id, {
                "togetherDuties": null,
                "togetherRegulations": null,
                "list": [],
                "togetherCount": null
            })
        }
        // eslint-disable-next-line
    }, [])


    const addPurchaser = (arrayHelpers) => {
        const arr = gVal("list", true, []);
        arrayHelpers.push({
            "name": null,
            "branch": null,
            "nationalIdNumber": null,
            "street": null,
            "city": null,
            "postCode": null,
            "country": "PL",
            "state": null,
            "nuts3": null,
            "phone": null,
            "fax": null,
            "email": null,
            "www": null
        });
        formikProps.setFieldValue(gId("togetherCount"), arr.length + 1);
    }

    const removePurchaser = (arrayHelpers, index) => {
        const arr = gVal("list", true, []);
        formikProps.setFieldValue(gId("togetherCount"), arr.length - 1)
        arrayHelpers.remove(index);
    }


    return (<>
        <NoticeTypography formTrKey={id}/>

        <Typography>To pole uzupełniane jest automaycznie poprzez dodawanie kolejnych wykonawców poniżej</Typography>
        <NoticeIntegerInput
            formikProps={formikProps}
            id={gId("togetherCount")}
            disabled
            required
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("togetherDuties")}
            required
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("togetherRegulations")}
        />

        <FieldArray
            name={gId("list")}
            render={(arrayHelpers) => (<>
                {!!gVal("form.purchaserData.together.list", false) &&
                    formikProps.values.form.purchaserData.together.list.map((item, index) => (
                        <PurchaserDataTogetherList key={index} id={gId("list." + index)} formikProps={formikProps} index={index}
                                                   removePurchaser={(index) => removePurchaser(arrayHelpers, index)}/>
                    ))
                }
                <Button disabled={!editable} Icon={PlusOneIcon} onClick={() => addPurchaser(arrayHelpers)}>{Tr('add_purchaser')}</Button>
            </>)}
        />
    </>)
}

PurchaserDataTogether.propTypes = {};

export default PurchaserDataTogether;
